<template>
    <div class="wrapper">
        <form method="post" autocomplete="off" @submit.prevent="selectLocation">
            <h1>{{ $t('labels.select_location') }}</h1>
            <div class="form-group">
                <label for="location" class="sr-only">{{ $t('labels.location') }}</label>
                <select name="location" id="location" class="form-control" v-model="selectedLocation">
                    <option value="">{{ $t('labels.select_location') }}</option>
                    <option v-for="location in locations" :key="location.id.toString()" :value="location.id">{{ location.name }}</option>
                </select>
            </div>
            <hr>

            <div class="row">
                <div class="col col-sm-6">
                    <h1>{{ $t('labels.choose_existing_device') }}</h1>
                    <div class="form-group">
                        <label for="device" class="sr-only">{{ $t('labels.device') }}</label>
                        <select name="device" id="device" class="form-control" :disabled="!selectedLocation" v-model="selectedDevice">
                            <option value="">{{ $t('labels.select_device') }}</option>
                            <option v-for="device in devices" :key="device.id.toString()" :value="device.id" v-text="getOptionText(device)"></option>
                        </select>
                    </div>
                </div>
                <div class="col col-sm-6 border-left">
                    <h1>{{ $t('labels.create_new_device') }}</h1>
                    <div class="form-group">
                        <label for="email" class="sr-only">{{ $t('labels.email') }}</label>
                        <input type="text" name="name" id="name" class="form-control" :placeholder="$t('labels.name')" :disabled="!selectedLocation || selectedDevice !== ''" v-model="name">
                    </div>

                    <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" value="1" id="register_workdays" v-model="regWorkdays" :disabled="!selectedLocation || selectedDevice !== '' || regActivities">
                        <label class="form-check-label" for="register_workdays">
                            {{ $t('labels.register_workdays') }}
                        </label>
                    </div>

                    <div class="form-check my-2">
                        <input class="form-check-input" type="checkbox" value="1" id="register_activities" v-model="regActivities" :disabled="!selectedLocation || selectedDevice !== '' || regWorkdays">
                        <label class="form-check-label" for="register_activities">
                            {{ $t('labels.register_activities') }}
                        </label>
                    </div>

                    <div class="form-check mt-2 mb-3">
                        <input class="form-check-input" type="checkbox" value="1" id="pre_register_activities" v-model="preReg" :disabled="!selectedLocation || selectedDevice !== '' || !regActivities">
                        <label class="form-check-label" for="pre_register_activities">
                            {{ $t('labels.pre_register_activities') }}
                        </label>
                    </div>
                </div>
            </div>

            <div class="text-right">
                <button class="btn btn-lg btn-danger mr-3" type="button" @click="cancel">{{ $t('labels.cancel') }}</button>
                <button class="btn btn-lg btn-primary btn--xl" type="submit" :disabled="submitDisabled">{{ $t('labels.save') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import * as config from '../config/config';

export default {
  name: 'choose-location',

  data() {
    return {
      ignoreConfigurationModal: false,
      selectedLocation: '',
      selectedDevice: '',
      name: '',
      regWorkdays: false,
      regActivities: false,
      preReg: false
    }
  },

  computed: {
    currentDevice() {
      return this.$store.getters.currentDevice
    },

    locations() {
      return this.$store.state.locations;
    },

    devices() {
      return this.$store.state.devices;
    },

    submitDisabled() {
      if (!this.selectedLocation) return true;
      if (this.selectedDevice) return false;
      if (this.selectedLocation && this.name && (this.regWorkdays || this.regActivities)) return false;

      return true;
    }
  },

  watch: {
    regActivities(val) {
      if (!val && this.preReg) this.preReg = false
    },

    locations(val) {
      if (val && val.length) this.selectedLocation = this.locations[0].id;
    },

    selectedLocation(val) {
      if (!val) return this.$store.commit('clearDevices');

      axios.post(
          config.api.baseUrl + '/devices',
          {location: val},
          {headers: {'Authorization': 'Bearer ' + this.$store.state.token}}
      ).then(res => {
        this.$store.commit('setDevices', res.data.devices);

        // Disabled because this doesn't work
        this.ignoreConfigurationModal = true;

        // let ids = res.data.devices.map(device => device.id);
        // if (!this.ignoreConfigurationModal && res.data.device && ids.indexOf(res.data.device.id) > -1) {
        //   if (confirm('Oude configuratie gevonden. Wilt u de oude configuratie laden?')) {
        //     this.$store.dispatch('setCurrentDevice', res.data.device);
        //     this.initDevice({
        //       location: res.data.device.location_id,
        //       device: res.data.device.id,
        //       name: res.data.device.name,
        //       register_workdays: res.data.device.register_workdays,
        //       register_activities: res.data.device.register_activities,
        //       pre_register_activities: res.data.device.pre_register_activities
        //     })
        //   } else {
        //     this.ignoreConfigurationModal = true;
        //   }
        // }
      });
    },

    selectedDevice(val) {
      if (!val) return;

      this.name = '';
      this.regWorkdays = false;
      this.regActivities = false;
      this.preReg = false;
    }
  },

  methods: {
    cancel() {
      this.$parent.logout(false);
    },

    getOptionText(device) {
      let str = '';
      let location = this.$store.getters.locationById(device.location_id);

      if (!this.selectLocation && location) str += location.name + ': ';
      return str + device.name;
    },

    selectLocation() {
      this.initDevice({
        location: this.selectedLocation,
        device: this.selectedDevice,
        name: this.name,
        register_workdays: this.regWorkdays,
        register_activities: this.regActivities,
        pre_register_activities: this.preReg
      });
    },
    initDevice(postData) {
      axios.post(config.api.baseUrl + '/init', postData, {headers: {'Authorization': 'Bearer ' + this.$store.state.token}})
          .then(response => {
            const data = response.data.data;

            this.$store.dispatch('setToken', data.token);
            this.$store.dispatch('setCurrentDevice', data.device);
            this.$store.dispatch('setCurrentLocation', data.location);
            this.$store.dispatch('setEmployees', data.employees);
            this.$store.commit('storeEmployeesOffline', data.employees);
            this.$store.dispatch('setRows', data.rows);
            this.$store.commit('storeRowsOffline', data.rows);
            this.$store.dispatch('setActivities', data.activities);
            this.$store.commit('storeActivitiesOffline', data.activities);
            this.$store.dispatch('setPackagings', data.packagings);
            this.$store.commit('storePackagingsOffline', data.packagings);
            this.$store.dispatch('setPercentages', data.percentages);
            this.$store.commit('storePercentagesOffline', data.percentages);
          })
          .catch(error => {
            console.log(error, error.response);

            if (error.response && error.response.data) {
              this.$store.dispatch('setError', 'errors.' + error.response.data);
            }
          })
    }
  },

  mounted() {
    if (this.locations && this.locations.length === 1) this.selectedLocation = this.locations[0].id;
  }
}
</script>
